var _circle, _path, _g, _g2, _path2, _path3, _circle2, _circle3, _circle4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg404Img = function Svg404Img(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 225,
    viewBox: "0 0 232 225",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 112.5,
    r: 112.5,
    fill: "#00B2B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7984 124.608V118.553L84.9795 94.6364H90.1997V103.017H87.1102L77.5399 118.163V118.447H99.113V124.608H69.7984ZM87.2522 131V122.761L87.3943 120.08V94.6364H94.6031V131H87.2522ZM118.493 131.799C115.439 131.787 112.812 131.036 110.61 129.544C108.42 128.053 106.733 125.892 105.549 123.063C104.378 120.234 103.798 116.831 103.809 112.854C103.809 108.888 104.395 105.509 105.567 102.715C106.751 99.9216 108.438 97.7969 110.628 96.3409C112.829 94.8731 115.451 94.1392 118.493 94.1392C121.535 94.1392 124.151 94.8731 126.341 96.3409C128.543 97.8087 130.236 99.9394 131.419 102.733C132.603 105.515 133.189 108.888 133.177 112.854C133.177 116.843 132.585 120.252 131.402 123.081C130.23 125.91 128.549 128.07 126.359 129.562C124.169 131.053 121.547 131.799 118.493 131.799ZM118.493 125.425C120.577 125.425 122.24 124.377 123.483 122.282C124.726 120.187 125.341 117.044 125.329 112.854C125.329 110.096 125.045 107.799 124.477 105.964C123.921 104.13 123.128 102.751 122.098 101.827C121.08 100.904 119.878 100.442 118.493 100.442C116.422 100.442 114.765 101.478 113.522 103.55C112.279 105.621 111.651 108.723 111.64 112.854C111.64 115.647 111.918 117.979 112.474 119.849C113.042 121.708 113.841 123.105 114.871 124.04C115.901 124.963 117.108 125.425 118.493 125.425ZM138.109 124.608V118.553L153.29 94.6364H158.51V103.017H155.421L145.85 118.163V118.447H167.424V124.608H138.109ZM155.563 131V122.761L155.705 120.08V94.6364H162.914V131H155.563Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2224 164.703C60.7303 185.673 92.7337 187.669 113.704 169.161L46.6807 93.2214C25.7104 111.729 23.7144 143.733 42.2224 164.703Z",
    fill: "url(#paint0_linear_1014_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0822 159.554C63.5038 177.275 90.3706 179.138 108.091 163.717L103.116 158.001L96.0007 149.5L52.2446 99.5456C34.5243 114.967 32.6607 141.834 48.0822 159.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0887 94.3028L49.5891 101.024L56.0549 108.32L98.0006 156L106.295 165.008L112.657 168.298L110.156 161.577L101.501 155L99.0006 148.989L59.9164 104.89L53.4507 97.5935L47.0887 94.3028Z",
    fill: "url(#paint1_linear_1014_6365)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1014_6365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.485 58.9682C168.676 40.2798 136.656 41.9995 117.968 62.8091L193.326 130.486C212.015 109.676 210.295 77.6565 189.485 58.9682Z",
    fill: "url(#paint2_linear_1014_6365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26 64.7601C166.892 48.9427 139.99 50.1997 124.172 67.5677L187.067 124.847C202.885 107.479 201.628 80.5775 184.26 64.7601Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.795 129.458L189.534 123.071L182.267 116.572L133.073 72.5768L125.807 66.0775L119.107 63.545L122.368 69.9318L129.634 76.4311L178.829 120.427L186.095 126.926L192.795 129.458Z",
    fill: "url(#paint3_linear_1014_6365)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 174.5C127.5 175.88 127.5 181.499 123 179.499C117.974 177.266 117 176.38 117 174.999C117 173.619 119.91 176 123.5 176C127.09 176 127.5 173.119 127.5 174.5Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 174.977C128 176.358 128.5 182 123 178.5C119.071 176 117 176.358 117 174.977C117 173.596 119.41 174.977 123 174.977C126.59 174.977 128 173.596 128 174.977Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 171,
    r: 1,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 179,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 181.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1014_6365",
    x1: 58.2379,
    y1: 85.526,
    x2: 101.964,
    y2: 176.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D5D3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1014_6365",
    x1: 50.8156,
    y1: 102.204,
    x2: 54.6753,
    y2: 98.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D5D3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BBBBB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A6A7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9A9B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969891"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1014_6365",
    x1: 182.737,
    y1: 139.466,
    x2: 128.737,
    y2: 53.7967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D5D3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1014_6365",
    x1: 188.179,
    y1: 122.042,
    x2: 184.741,
    y2: 125.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D5D3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BBBBB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A6A7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9A9B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969891"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_6365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.287,
    height: 101.287,
    fill: "white",
    transform: "translate(69.2725 60.4084) rotate(36.2302)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1014_6365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.287,
    height: 101.287,
    fill: "white",
    transform: "translate(174.682 165.692) rotate(-150.413)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404Img, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404_img.93a59c61.svg";
export { ForwardRef as ReactComponent };